import { create } from 'zustand';
import { ANALYTICS_SOURCES } from '../Utils/constant';

type Analytics = {
    source: string,
    userId: string,
    email: string,
    persona: string,
    username: string,
    setSource: (source: string) => void;
    setUserId: (userId: string) => void;
    setEmail: (email: string) => void;
    setPersona: (persona: string) => void;
    setUsername: (username: string) => void;
};

const useAnalyticsStore = create<Analytics>((set) => ({
    source: ANALYTICS_SOURCES.TRY_ON,
    userId: '',
    email: '',
    persona: '',
    username: '',
    setSource: (source) => set({ source }),
    setUserId: (userId) => set({ userId }),
    setEmail: (email) => set({ email }),
    setPersona: (persona) => set({ persona }),
    setUsername: (username) => set({ username }),
}));

const analyticsStoreState = useAnalyticsStore.getState;

export { analyticsStoreState };

export default useAnalyticsStore;
